import * as React from 'react'
import styled from 'styled-components'
import { calcFontScale } from '../../styles/calcFontScale'
import { SPACE } from '../../styles/constants'

interface Props {
  title: string
}
export const AuthHeader: React.SFC<Props> = ({ title, children }) => (
  <header>
    <Title>{title}</Title>
    {children}
  </header>
)

const Title = styled.h2`
  ${calcFontScale(1)};
  ${SPACE.stack.xs};
`



// WEBPACK FOOTER //
// ./src/components/AuthHeader/index.tsx